module.exports = __webpack_public_path__ + "img/P150T_weapon_27.410be9a8.png";